module.exports = __webpack_public_path__ + "static/img/exit1.f5814eab.png";